import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { countEventService } from '../../events/countEvent';
import { BUSINESS_API_PREFIX } from '../constants';

export const acceptInvitation = async ({
    organizationId,
    invitationId,
    needsMigration,
    source = '',
}: {
    organizationId: string;
    invitationId: string;
    needsMigration: boolean;
    source?: string;
}) => {
    try {
        const data = await axios.post(`${BUSINESS_API_PREFIX}/invitation/accept`, {
            organization_id: organizationId,
            invitation_id: invitationId,
            needs_migration: needsMigration,
        });

        countEventService({ metric: 'accept_invitation', status: 'success', source });

        return data;
    } catch (error) {
        let responseData: unknown | undefined;
        if (axios.isAxiosError(error) && error.response?.data) {
            responseData = JSON.stringify(error.response?.data);
        }
        logger.error(error as any, {
            message: `Error accepting invitation`,
            responseData,
            flow: 'acceptInvitation',
            organizationId,
            invitationId,
        });
        countEventService({ metric: 'accept_invitation', status: 'fail', source });
        throw error;
    }
};
